<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品ID" prop="id">
              <el-input
                  v-model="form.product_id"
                  maxlength="30"
                  show-word-limit
                  disabled
                  style="width:33%"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-col :span="15">
                <el-input
                    v-model="productInfo.title"
                    placeholder="请选择商品"
                    :disabled="true"
                ></el-input>
              </el-col>
              <el-button type="primary" size="small" @click=" search.chooseOrgVisible = true; searchData();">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>


      <el-dialog
          title="选择商品"
          :visible.sync="search.chooseOrgVisible"
          :close-on-click-modal="true"
          :before-close="addEditFormOnClose"
          width="75%"
      >
        <el-form :inline="true" :model="search.query">
          <!-- 模糊查询 -->
          <el-form-item>
            <el-input
                size="small"
                v-model="search.query.search"
                placeholder="请输入标题"
                clearable
                @blur="searchData()"
            />
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                size="small"
                @click="
              searchData();
            "
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>

        <!--列表-->
        <el-table
            border
            :data="search.result.data"
            highlight-current-row
            v-loading="search.listLoading1"
            style="..."
        >
          <el-table-column prop="id" label="ID" align="center"></el-table-column>
          <el-table-column
              prop="title"
              label="标题"
              align="center"
          ></el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="{ row }">
              <img :src="row.img_url" style="width: 40px" alt="" />
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="{ row }">
              <el-button type="primary" size="small" @click="selectProduct(row)">
                确定
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            @current-change="searchData"
            :current-page.sync="search.query.page"
            :page-size="search.query.limit"
            layout="total, prev, pager, next, jumper"
            :total="search.result.total"
        >
        </el-pagination>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import {
    getProductInfo
} from "@/api/mall";

import {
  getProductRelationInfo,updateProductRelationInfo
} from "@/api/productCollection";

import {
  flashSaleProductScreen,
} from "@/api/promotion";

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        product_id: '',
        product_collection_id: '',
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
      productInfo:{
        title:''
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.form.product_collection_id = this.$route.query.collection_id;
    if (this.id != 0) {
      this.getInfo();
    }else{
      this.form.id = 0;
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getProductRelationInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.form = response.data
        this.productInfo.title = response.data.title
        //this.getProductInfo();
      });
    },
    getProductInfo(){
      this.formLoading = true;
      getProductInfo({
        id: this.form.product_id
      }).then(response => {
        this.formLoading = false
        this.productInfo.title = response.data.title
      });
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      flashSaleProductScreen(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.form.product_id = row.id;
      this.productInfo.title = row.title;
      this.productInfo.product_sku = row.product_sku;
      this.search.chooseOrgVisible = false;
      this.productSkuShow = true;
    },
    onSave() {
      this.onSaveLoading = true;
      let that = this
      updateProductRelationInfo(this.form).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 2000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });

    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
</style>